/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_NumberInputs */

const en__field_number = /** @type {(inputs: _Field_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number`)
};

/**
* | output |
* | --- |
* | "Number" |
*
* @param {_Field_NumberInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const _field_number = /** @type {((inputs?: _Field_NumberInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_NumberInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_number(inputs)
});